'use client';

import React from 'react';
import { useAppState } from '@/state/hooks/app.state.hook';

export const BlockTitle: React.FC<{ title: string }> = ({ title }) => {
  const { initialBoot } = useAppState();
  const sectionTextColor = initialBoot?.theme?.general?.sectionTextColor || '#ffffff';
  const sectionLabelFont = initialBoot?.theme?.general?.sectionLabelFont || undefined;

  return (
    <div className='flex w-full items-center gap-8 md:gap-10'>
      <div className='h-px flex-1' style={{ backgroundColor: sectionTextColor }}></div>
      <h2 data-testid="BlockItem-Title" className='text-lg font-black md:text-[32px]' style={{ color: sectionTextColor, fontFamily: sectionLabelFont }}>{title}</h2>
      <div className='h-px flex-1' style={{ backgroundColor: sectionTextColor }}></div>
    </div>
  );
};